import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=78bb18f2&scoped=true&"
import script from "./Information.vue?vue&type=script&lang=js&"
export * from "./Information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bb18f2",
  null
  
)

component.options.__file = "Information.vue"
export default component.exports